<template>
  <WdsStack direction-row justify-space-between align-center gap-sm class="tw-py-0.5">
    <WdsText v-if="data.title" :text="data.title" secondary sm />
    <WdsStack direction-row align-center gap-xs class="tw-min-w-0 tw-flex-1 tw-justify-end">
      <a
        :href="data.file.url"
        target="_blank"
        :title="data.file.name"
        class="tw-text-indigo-600 hover:tw-underline tw-text-sm tw-truncate tw-max-w-[160px]"
      >
        {{ data.file.name }}
      </a>
      <WdsIcon name="document" :size="16" />
    </WdsStack>
  </WdsStack>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsIcon, WdsStack, WdsText } from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'

const ComplianceDataFileFragment = graphql(`
  fragment ComplianceDataFile on ComplianceDataFile {
    title
    file {
      id
      name
      url
    }
  }
`)

const props = defineProps<{ entry: FragmentType<typeof ComplianceDataFileFragment> }>()
const data = computed(() => useFragment(ComplianceDataFileFragment, props.entry))
</script>
